export function setCookie(
  name,
  value,
  minutes // 만료일 (일수)
) {
  const enc = encodeURIComponent; // 안전하게 인코딩
  let cookie = `${enc(name)}=${enc(value)}`;

  if (typeof days === "number") {
    const d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    cookie += `; Expires=${d.toUTCString()}`;
  }

  document.cookie = cookie;
}

export function getCookie(name) {
  const enc = encodeURIComponent;
  const target = `${enc(name)}=`;
  const parts = document.cookie.split("; ");
  for (const p of parts) {
    if (p.startsWith(target)) {
      return decodeURIComponent(p.substring(target.length));
    }
  }
  return null;
}

export function deleteCookie(name) {
  setCookie(name, "", -1);
}
